<template>
    <a class="close">
        <img src="/nuxt-assets/icons/close-light.svg" width="15" height="15" alt="close" />
    </a>
</template>

<style lang="scss" scoped>
.close {
    padding: 10px;
    border-radius: 100px;
    line-height: 0;
    transition: 0.2s all;

    &:hover {
        background-color: $color-grey;
        cursor: pointer;
    }
}
</style>
